import { SnackbarStyle } from '@/constants/constants'
import i18n from '@/i18n'
import { alertEventService } from '@/services/alertEvent.service'
import { authService } from '@/services/auth.service'
import { DialogUser } from "@/tools/dialog"
import moment from 'moment'
import Vue from 'vue'
import { mapActions } from 'vuex'
import AlertEventDialogEventsTabComponent from './tabs/events/AlertEventDialogEventsTabComponent.vue'
import AlertEventDialogExcludedRulesTabComponent from './tabs/excludedRules/AlertEventDialogExcludedRulesTabComponent.vue'
import AlertEventDialogNotificationTabComponent from './tabs/notification/AlertEventDialogNotificationTabComponent.vue'
import AlertEventDialogSuccesfulRulesTabComponent from './tabs/successfulRules/AlertEventDialogSuccesfulRulesTabComponent.vue'
import AlertEventDialogThingsTabComponent from './tabs/things/AlertEventDialogThingsTabComponent.vue'
import AlertEventDialogUsersTabComponent from './tabs/users/AlertEventDialogUsersTabComponent.vue'


import { thingService } from '@/services/thing.service'
import { userService } from '@/services/user.service'
import { clone } from 'ramda'

export default {
    name: 'AlertEventDialogComponent',
    components: {
        AlertEventDialogThingsTabComponent,
        AlertEventDialogUsersTabComponent,
        AlertEventDialogEventsTabComponent,
        AlertEventDialogSuccesfulRulesTabComponent,
        AlertEventDialogExcludedRulesTabComponent,
        AlertEventDialogNotificationTabComponent
    },
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // key del reporte
        key: '',
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        alertEventDialogThingTabForm: {
            key: 'alertEventDialogThingTabForm',
            tab: i18n.t('alertEvent.editDialog.tabs.things'),
            tooltip: i18n.t('alertEvent.editDialog.tabs.thingsTooltip'),
            icon: 'mdi-tractor',
            disabled: true,
            content: {
                _uid: 'oLkbANttlv',
                component: 'AlertEventDialogThingsTabComponent',
                headline: 'AlertEventDialogThingsTabComponent'
            },
            model: {
                thingIdsResult: [],
                thingIds: [],
                thingsData: [],
            },
            validForm: false
        },
        alertEventDialogUserTabForm: {
            key: 'alertEventDialogUserTabForm',
            tab: i18n.t('alertEvent.editDialog.tabs.users'),
            tooltip: i18n.t('alertEvent.editDialog.tabs.usersTooltip'),
            icon: 'mdi-account-multiple',
            disabled: true,
            content: {
                _uid: 'oLkbANttlv',
                component: 'AlertEventDialogUsersTabComponent',
                headline: 'AlertEventDialogUsersTabComponent'
            },
            model: {
                userIds: [],
                usersData: [],
            },
            validForm: false
        },
        alertEventDialogEventTabForm: {
            key: 'alertEventDialogEventTabForm',
            tab: i18n.t('alertEvent.editDialog.tabs.events'),
            tooltip: i18n.t('alertEvent.editDialog.tabs.eventsTooltip'),
            icon: 'mdi-state-machine',
            disabled: true,
            content: {
                _uid: 'oLkbANttlv',
                component: 'AlertEventDialogEventsTabComponent',
                headline: 'AlertEventDialogEventsTabComponent'
            },
            model: {
                eventIds: []
            },
            validForm: false
        },
        alertEventDialogSuccesfulRulesTabForm: {
            key: 'alertEventDialogSuccesfulRulesTabForm',
            tab: i18n.t('alertEvent.editDialog.tabs.successfulRules'),
            tooltip: i18n.t('alertEvent.editDialog.tabs.successfulRulesTooltip'),
            icon: 'mdi-playlist-plus',
            disabled: false,
            content: {
                _uid: 'oLkbANttlv',
                component: 'AlertEventDialogSuccesfulRulesTabComponent',
                headline: 'AlertEventDialogSuccesfulRulesTabComponent'
            },
            model: {
                tableData: [],
                tableHeaders: [],
            },
            validForm: false
        },
        alertEventDialogExcludedRulesTabForm: {
            key: 'alertEventDialogExcludedRulesTabForm',
            tab: i18n.t('alertEvent.editDialog.tabs.excludedRules'),
            tooltip: i18n.t('alertEvent.editDialog.tabs.excludedRulesTooltip'),
            icon: 'mdi-playlist-remove',
            disabled: false,
            content: {
                _uid: 'oLkbANttlv',
                component: 'AlertEventDialogExcludedRulesTabComponent',
                headline: 'AlertEventDialogExcludedRulesTabComponent'
            },
            model: {
                tableData: [],
                tableHeaders: [],
            },
            validForm: false
        },
        alertEventDialogNotificationTabComponent: {
            key: 'alertEventDialogNotificationTabForm',
            tab: i18n.t('alertEvent.editDialog.tabs.notification'),
            tooltip: i18n.t('alertEvent.editDialog.tabs.notificationTooltip'),
            icon: 'mdi-pencil',
            disabled: false,
            content: {
                _uid: 'oLkbANttlv',
                component: 'alertEventDialogNotificationTabComponent',
                headline: 'alertEventDialogNotificationTabComponent'
            },
            model: {
                title: i18n.t('alertEvent.editDialog.notification.defaultTitle'),
                subject: i18n.t('alertEvent.editDialog.notification.defaultSubject'),
                messageBody: ''
            },
            validForm: false
        },
        tabs: [],
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
            requiredWithCheck: (check, value) => !check || !!value || `${i18n.t('required')}`,
            min: (value, minValue) => !value || value.length >= minValue || `${i18n.t('min', { min: minValue })}`,
        },
        // flag para resetear validaciones en los formularios
        resetForms: false,
        validAlertEvents: [],
        loading: false
    }),
    computed: {
    },
    created() {
    },
    beforeMount() {
        // pusheo los tabs
        this.tabs.push(this.alertEventDialogNotificationTabComponent)
        this.tabs.push(this.alertEventDialogThingTabForm)
        this.tabs.push(this.alertEventDialogUserTabForm)
        this.tabs.push(this.alertEventDialogEventTabForm)
        this.tabs.push(this.alertEventDialogSuccesfulRulesTabForm)
        this.tabs.push(this.alertEventDialogExcludedRulesTabForm)
    },
    mounted() {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.alertEventDialogUserTabForm.model.userIds = []
            this.alertEventDialogEventTabForm.model.eventIds = []

            // tab de equipos asignados
            this.alertEventDialogThingTabForm.model.thingIdsResult = []
            this.alertEventDialogThingTabForm.model.thingIds = []
            this.alertEventDialogThingTabForm.model.thingsData = []

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function () {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogUser)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const alertEventDto = this.validAlertEvents;
            const result = alertEventService.processNotifications(this.alertEventDialogUserTabForm.model.userIds, this.alertEventDialogNotificationTabComponent.model, alertEventDto);
            alertEventService.create(result).then(async () => {
                this.showSnackbar({
                    visible: true,
                    text:
                        alertEventDto.length > 1 ?
                            this.$t('alertEvent.successCreateMultipleMessage') : this.$t('alertEvent.successCreateMessage'),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS
                })
                this.resetFields()
                await authService.refreshTokenPayload()
                this.$emit('commitAlertEvent')
                this.cancel()
            })
        },
        /**
         * Convierte una fecha en formato DD/MM/YYYY a timestamp unix
         */
        dateTimestamp(date) {
            return date ? moment(date).unix() : null
        },
        /**
         * Remueve las empresas, sectores y equipos no asignados al usuario
         */
        processThingsNested(data) {
            data.forEach(element => {
                if (element.nodeType == 'ENTERPRISE') {
                    element.children.forEach(el => {
                        if (el.nodeType == 'GROUP') {
                            el.children = el.children.filter(e => !e.disabled)
                            if (el.children.length > 0) {
                                el.disabled = false;
                            }
                        }
                    })
                    element.children = element.children.filter(e => !e.disabled)
                    if (element.children.length > 0) {
                        element.disabled = false;
                    }
                }
                else if (element.nodeType == 'GROUP') {
                    element.children = element.children.filter(e => !e.disabled)
                    if (element.children.length > 0) {
                        element.disabled = false;
                    }
                }
            })
            return data.filter(e => !e.disabled);
        },
        parseData(data) {
            const successHeaders = clone(data.headers.filter(header => header.value != 'reason'))
            this.alertEventDialogSuccesfulRulesTabForm.model.tableHeaders.cleanAndUpdate(successHeaders)
            this.alertEventDialogSuccesfulRulesTabForm.model.tableData.cleanAndUpdate(data.data.successfulRules)

            this.validAlertEvents.cleanAndUpdate(data.data.validAlertEvents)

            const excludedHeaders = clone(data.headers)
            this.alertEventDialogExcludedRulesTabForm.model.tableHeaders.cleanAndUpdate(excludedHeaders)
            this.alertEventDialogExcludedRulesTabForm.model.tableData.cleanAndUpdate(data.data.excludedRules)
        },
        fetchData() {
            alertEventService.findAlertsByKey(this.alertEventDialogUserTabForm.model.userIds, this.key).then((data) => {
                this.parseData(data);
                let finished = data.data.finished;
                if(finished) {
                    this.key = '';
                } else {
                    setTimeout(this.fetchData, 3000);
                }
            }).catch(err => { 
                console.log(err);
                this.key = '';
            });
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: async function (newModel) {
                if (newModel) {
                    this.alertEventDialogUserTabForm.model.usersData = await userService.getAllForSelector()
                    this.alertEventDialogUserTabForm.disabled = false;
                    this.alertEventDialogUserTabForm.model.userIds.cleanAndUpdate(newModel.userIds)

                    this.alertEventDialogEventTabForm.model.eventIds.cleanAndUpdate(newModel.eventIds)
                    this.alertEventDialogEventTabForm.disabled = false;
                    // Cargamos todas las empresas y grupos con sus cosas
                    const enterpriseIds = this.model.enterpriseIds.filter(e => e._id !== 'ALL').map(e => e._id);
                    await thingService.getThingsNestedInEnterprises(enterpriseIds, []).then(data => {
                        this.alertEventDialogThingTabForm.model.thingsData = this.processThingsNested(data);
                    })
                    this.alertEventDialogThingTabForm.model.thingIds.cleanAndUpdate(newModel.thingIds)
                    this.alertEventDialogThingTabForm.model.thingIdsResult.cleanAndUpdate(newModel.thingIdsResult)
                    this.alertEventDialogThingTabForm.disabled = false;
                }
            }
        },
        'alertEventDialogUserTabForm.model.userIds': {
            deep: true,
            immediate: true,
            handler: async function (newModel) {
                if (this.alertEventDialogUserTabForm.model.userIds.length > 0 && this.alertEventDialogEventTabForm.model.eventIds.length > 0 && this.alertEventDialogThingTabForm.model.thingIdsResult.length > 0) {
                    this.key = await alertEventService.generateKey(newModel, this.alertEventDialogEventTabForm.model.eventIds, this.alertEventDialogThingTabForm.model.thingIdsResult)
                }
                else {
                    this.alertEventDialogSuccesfulRulesTabForm.model.tableHeaders.cleanAndUpdate([])
                    this.alertEventDialogSuccesfulRulesTabForm.model.tableData.cleanAndUpdate([])
                    this.validAlertEvents.cleanAndUpdate([])
                    this.alertEventDialogExcludedRulesTabForm.model.tableHeaders.cleanAndUpdate([])
                    this.alertEventDialogExcludedRulesTabForm.model.tableData.cleanAndUpdate([])
                }
            }
        },
        'alertEventDialogEventTabForm.model.eventIds': {
            deep: true,
            immediate: true,
            handler: async function (newModel) {
                if (this.alertEventDialogUserTabForm.model.userIds.length > 0 && this.alertEventDialogEventTabForm.model.eventIds.length > 0 && this.alertEventDialogThingTabForm.model.thingIdsResult.length > 0) {
                    this.key = await alertEventService.generateKey(this.alertEventDialogUserTabForm.model.userIds, newModel, this.alertEventDialogThingTabForm.model.thingIdsResult)
                }
                else {
                    this.alertEventDialogSuccesfulRulesTabForm.model.tableHeaders.cleanAndUpdate([])
                    this.alertEventDialogSuccesfulRulesTabForm.model.tableData.cleanAndUpdate([])
                    this.validAlertEvents.cleanAndUpdate([])

                    this.alertEventDialogExcludedRulesTabForm.model.tableHeaders.cleanAndUpdate([])
                    this.alertEventDialogExcludedRulesTabForm.model.tableData.cleanAndUpdate([])
                }
            }
        },
        'alertEventDialogThingTabForm.model.thingIdsResult': {
            deep: true,
            immediate: true,
            handler: async function (newModel) {
                if (this.alertEventDialogUserTabForm.model.userIds.length > 0 && this.alertEventDialogEventTabForm.model.eventIds.length > 0 && this.alertEventDialogThingTabForm.model.thingIdsResult.length > 0) {
                    this.key = await alertEventService.generateKey(this.alertEventDialogUserTabForm.model.userIds, this.alertEventDialogEventTabForm.model.eventIds, newModel)
                }
                else {
                    this.alertEventDialogSuccesfulRulesTabForm.model.tableHeaders.cleanAndUpdate([])
                    this.alertEventDialogSuccesfulRulesTabForm.model.tableData.cleanAndUpdate([])
                    this.validAlertEvents.cleanAndUpdate([])

                    this.alertEventDialogExcludedRulesTabForm.model.tableHeaders.cleanAndUpdate([])
                    this.alertEventDialogExcludedRulesTabForm.model.tableData.cleanAndUpdate([])
                }
            }
        },
        async key(newValue) {
            if(newValue != '') {
                this.fetchData();
            }
        }
    }
}
